import {
    Component,
    ElementRef,
    EventEmitter,
    HostBinding,
    HostListener,
    Input,
    Output,
    ViewChild
} from '@angular/core';

import { SelectableItemComponent } from '../../../basic/selectable-item/selectable-item.component';

@Component({
    selector: 'ridango-calendar-day',
    templateUrl: './calendar-day.component.html',
    styleUrls: ['./calendar-day.component.scss'],
})
export class CalendarDayComponent extends SelectableItemComponent {
    @Input() current = true;
    @Input() tabindex: number;
    @Input() day: string;
    @Input() fullDate: string;

    @Output() onKeyDown = new EventEmitter<any>();

    @ViewChild('calendarDay') daySelector: ElementRef;

    @HostBinding('class') class = 'calendar-day-wrapper';

    constructor(public eRef: ElementRef) {
        super();
    }

    @HostListener('keydown', ['$event'])
    handleKeyDown(event: KeyboardEvent) {
        this.onKeyDown.emit({ event: event, calendarDay: this.item });
    }

    setFocus() {
        setTimeout(() => this.daySelector.nativeElement.focus());
    }
}
